import React from "react";
import styled from "@emotion/styled";

interface PageLayoutProps {
  children: React.ReactNode;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  width: 600px;
`;

const TitleContainer = styled.div`
  padding: 36px 0 32px 0;
`;

export const PageContainer: React.FC<PageLayoutProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export const PageContentContainer: React.FC<PageLayoutProps> = ({ children }) => {
  return <ContentContainer>{children}</ContentContainer>;
};

export const PageTitleContainer: React.FC<PageLayoutProps> = ({ children }) => {
  return <TitleContainer>{children}</TitleContainer>;
};
